import * as React from 'react';

const TrashBin24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M9.75 8a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-1.5 0v-8.5A.75.75 0 0 1 9.75 8m4.5 0a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-1.5 0v-8.5a.75.75 0 0 1 .75-.75"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8.25 4V2.75C8.25 1.784 9.034 1 10 1h4c.966 0 1.75.784 1.75 1.75V4h4.5a.75.75 0 0 1 0 1.5h-1.214v14.75c0 1.61-1.457 2.75-3.036 2.75H8c-1.58 0-3.036-1.14-3.036-2.75V5.5H3.75a.75.75 0 0 1 0-1.5zm1.5-1.25V4h4.5V2.75A.25.25 0 0 0 14 2.5h-4a.25.25 0 0 0-.25.25m7.786 2.75H6.464v14.75c0 .6.59 1.25 1.536 1.25h8c.945 0 1.536-.65 1.536-1.25z"
  }
));
TrashBin24.Size = 24;
TrashBin24.Title = "TrashBin";

export { TrashBin24 as default };
